<template>
  <div v-if="list && list.length" class="homeWrap mainBox newsWrap wow animate__animated animate__fadeIn">
    <div class="newsItem topNews" @click="navTo('/news/detail', { id: list[0].id })">
      <OssImg class="newsPic maria03" fit="cover" :src="list[0].newsOssUrl" style="margin-bottom: 1rem"></OssImg>
      <div class="newsInfo">
        <div class="newsTitle ellipsis">{{ list[0].newsTitle }}</div>
        <div class="newsSubTitle">{{ list[0].newsSubTitle }}</div>
        <div class="location">
          <OssImg class="timeImg" src="/UIV3/time.png" alt="" />
          {{ list[0].createTime?.substring(0, 10) }}
        </div>
      </div>
    </div>
    <div class="rightNews">
      <div class="rightTitle">新闻</div>
      <div class="rightSubTitle">让你快捷了解并触达我们</div>
      <div class="newsItem rowNews" v-for="(item, index) in list.slice(1, 6)" :key="index"
        @click="navTo('/news/detail', { id: item.id })">
        <OssImg class="newsPic maria" fit="cover" :src="item.newsOssUrl" v-if="index <= 1"></OssImg>
        <div class="newsInfo">
          <div class="newsTitle ellipsis">{{ item.newsTitle }}</div>
          <div class="newsSubTitle ellipsis-multiline" v-if="index <= 1">
            {{ item.newsSubTitle }}
          </div>
          <div class="location">
            <OssImg class="timeImg" src="/UIV3/time.png" alt="" />
            {{ item.createTime?.substring(0, 10) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import NewsApi from "@/api/newsApi";
import { navTo } from "@/utils/util";
const newsApi = new NewsApi();

const list = ref([]);

onMounted(() => {
  getList();
});

//获取列表
const getList = async () => {
  let res = await newsApi.getNewsList();
  list.value = res.rows.slice(0, 6) || [];
};
</script>

<style lang="scss" scoped>
@import "./home.scss";

.newsWrap {
  display: flex;
  flex-direction: row !important;
  align-items: flex-start !important;
  margin-top: 3.5rem;
  margin-bottom: 8rem;

  .newsItem {
    flex: 1;
    margin-right: 1.5rem;

    &:hover {

      .newsTitle,
      .newsSubTitle {
        color: var(--primary-color);
      }
    }

    .newsPic {
      flex: 1;
      height: 36rem;
      border-radius: 1rem;
      object-fit: cover;
      overflow: hidden;
    }

    .newsTitle,
    .newsSubTitle {
      font-size: 1rem;
      line-height: 1.375rpx;
      margin-bottom: 1rem;
      text-align: justify;
      font-weight: 600;
      color: #424242;
      cursor: pointer;
    }

    .location {
      display: flex;
      align-items: center;

      .timeImg {
        width: 1rem;
        height: 1rem;
        margin-right: 0.5rem;
      }

      font-size: 0.875rem;
      font-weight: 500;
      line-height: 1.25rem;
      color: #bbbbbb;
    }
  }

  .rowNews {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 0.625rem;

    .newsPic {
      margin-right: 2.5rem;
      flex: 1;
      height: 10.25rem;
    }

    .newsInfo {
      flex: 1;

      .newsSubTitle {
        -webkit-line-clamp: 4;
        width: 100%;
      }
    }
  }

  .rightNews {
    flex: 1;

    .rightTitle {
      font-weight: 600;
      font-size: 4rem;
      line-height: 5.625rem;
      margin-bottom: 1.5rem;
      cursor: pointer;
    }

    .rightSubTitle {
      font-weight: 500;
      font-size: 2rem;
      line-height: 2.8125rem;
      margin-bottom: 1rem;
      cursor: pointer;
    }
  }
}

// @media(max-width: 768px) {
//   .topNews {
//     display: none;
//   }
// }</style>
